import { render, staticRenderFns } from "./suppliesFormOutside.vue?vue&type=template&id=1352139e"
import script from "./suppliesFormOutside.vue?vue&type=script&lang=js"
export * from "./suppliesFormOutside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports